import { render, staticRenderFns } from "./SunuPayement.vue?vue&type=template&id=adce3d38&scoped=true"
import script from "./SunuPayement.vue?vue&type=script&lang=js"
export * from "./SunuPayement.vue?vue&type=script&lang=js"
import style0 from "./SunuPayement.vue?vue&type=style&index=0&id=adce3d38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adce3d38",
  null
  
)

export default component.exports